module.exports = __webpack_public_path__ + "img/47.7838cf40.jpg";